import { Stack } from '@mui/material';
import { Dispatch, SetStateAction, useRef } from 'react';
import * as React from 'react';

import { Tile, TileProps } from '@/components/diagrams/components/Tile';
import { TileVariant } from '@/components/diagrams/components/Tile/types';
import { MenuPopper } from '@/components/poppers/MenuPopper/MenuPopper';

import { ButtonRoot } from './ButtonRoot';
import { CommonButtonProps } from './types';

export type TileButtonWithPopoverProps = React.PropsWithChildren<
  Omit<CommonButtonProps, 'size' | 'variant'>
> & {
  tileProps: Partial<TileProps>;
  menuIsOpen: boolean;
  setMenuIsOpen: Dispatch<SetStateAction<boolean>>;
};

export function TileButtonWithPopover(props: TileButtonWithPopoverProps) {
  const { children, tileProps, menuIsOpen, setMenuIsOpen, ...buttonRootProps } =
    props;
  const menuButtonRef = useRef<HTMLButtonElement>(null);

  function handleClick(e: React.MouseEvent<HTMLButtonElement>) {
    e.stopPropagation();
    setMenuIsOpen((isOpen) => !isOpen);
  }

  return (
    <Stack
      sx={{
        display: 'flex',
        height: '100%',
      }}
    >
      <MenuPopper
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        transformOrigin={{ horizontal: 'left', vertical: 0 }}
        open={menuIsOpen}
        anchorRef={menuButtonRef}
        onClose={() => setMenuIsOpen(false)}
        elevation={8}
      >
        {children}
      </MenuPopper>
      <ButtonRoot
        variant="transparent"
        size="sm"
        ref={menuButtonRef}
        sx={{
          display: 'flex',
          padding: 0,
          height: '100%',
          alignSelf: 'stretch',
          textAlign: 'left',
        }}
        onClick={handleClick}
        {...buttonRootProps}
      >
        <Tile
          lineOne="Select entity"
          variant={TileVariant.Default}
          isGrouped={false}
          isSelected={false}
          {...tileProps}
        />
      </ButtonRoot>
    </Stack>
  );
}
